export default __webpack_public_path__ + "bd632ae620572fe547f1decd4489524e.svg";